// src/app/components/Contact/pictures.js

import DeleteAccountIMG from '../../../assets/delete_account.png'
import AlertsIMG from '../../../assets/alerts.png'
import ConnexionSecurityIMG from '../../../assets/connexion_security.png'
import SignalClassifiedIMG from '../../../assets/signal_classified.png'
import MyAccountIMG from '../../../assets/my_account.png'
import StopAlertsIMG from '../../../assets/stop_alerts.png'
import LoggingIMG from '../../../assets/logging.png'
import MyAccountScreenShotIMG from '../../../assets/my_account_screenshot.png'

export const PICTURES = {
  deleteAccount: DeleteAccountIMG,
  alerts: AlertsIMG,
  connexionSecurity: ConnexionSecurityIMG,
  signalClassified: SignalClassifiedIMG,
  myAccount: MyAccountIMG,
  stopAlerts: StopAlertsIMG,
  logging: LoggingIMG,
  myAccountScreenShot: MyAccountScreenShotIMG,
}
